<script setup lang="ts">
import { IconBagFill } from "@packages/icon-library";
import { HeaderCityAutocomplete } from "@/modules/app-header";
import MobileHeaderCitySelector from "./MobileHeaderCitySelector.vue";
import { computed, ComputedRef, onMounted, ref } from "vue";
import { useCartStore } from "@/modules/cart-module";
import { IUser, useUserStore } from "@/modules/user-module";
import { useRoute } from "vue-router";

const userStore = useUserStore();
const user: ComputedRef<null | IUser> = computed(() => userStore.user);
const showSelectCityModal = ref(false);
const showCityAutocomplete = ref(false);

const cartStore = useCartStore();
const route = useRoute();

const changeUserCity = () => {
  showSelectCityModal.value = true;
  showCityAutocomplete.value = false;
};

onMounted(() => {
  if (!localStorage.userCity && route.name !== "OrderPayment") {
    showCityAutocomplete.value = true;
  }
});
</script>

<template>
  <header class="mobile-header">
    <div class="container">
      <RouterLink :to="{ name: 'HomeView' }">
        <img src="@/assets/logo.svg" alt="logotype" />
      </RouterLink>

      <div class="mobile-header__actions">
        <RouterLink v-if="user" :to="{ name: 'CartView' }">
          <span v-if="cartStore.getCartProductsLength">
            {{
              cartStore.getCartProductsLength <= 9
                ? cartStore.getCartProductsLength
                : "9+"
            }}
          </span>
          <IconBagFill />
        </RouterLink>
      </div>
    </div>
  </header>

  <HeaderCityAutocomplete
    v-if="showCityAutocomplete"
    @change="changeUserCity"
    @close="showCityAutocomplete = false"
  />

  <MobileHeaderCitySelector
    v-if="showSelectCityModal"
    @close="showSelectCityModal = false"
  />
</template>

<style scoped lang="scss">
.mobile-header {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  clip-path: inset(0 -100vmax);
  border-bottom: 1px solid var(--color-semantic-border-normal-soft);
  background-color: var(--color-semantic-background-normal-bg-primary);
  z-index: 5;
  height: 56px;

  > .container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: calc($base-space / 2);

    > button,
    a {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      > .icon {
        width: 20px;
        height: 20px;
        background-color: var(--color-semantic-content-normal-primary);
      }
    }

    > a {
      position: relative;

      > span:not(.icon) {
        width: 16px;
        height: 16px;
        @include caption();
        border-radius: 50%;
        background-color: var(--color-semantic-background-normal-brand);
        color: var(--color-semantic-content-normal-static-dark);
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        z-index: 2;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>
